import { useMemo } from "react";
import { useIntl } from "react-intl";
import * as Yup from "yup";

export const FIELDS = {
  NAME: 'name',
  AMOUNT: 'amount',
  FEE_AMOUNT: 'feeAmount',
  ADMIN_WITHDRAWAL_FEE_AMOUNT: 'adminWithdrawalFeeAmount',
  FAST_WITHDRAWAL_FEE_AMOUNT: 'fastWithdrawalFeeAmount',
  ADMIN_NOTE: 'adminNote',
  BILL_ACCOUNT_ID: 'billAccountId',
}

export const useValidationSchema = () => {
  const intl = useIntl();

  return useMemo(() => {
    return Yup.object().shape({
      [FIELDS.AMOUNT]: Yup.number().min(0.01, intl.formatMessage({ id: "numberMinError" })).nullable().required(intl.formatMessage({ id: "amountRequiredError" })),
      [FIELDS.FEE_AMOUNT]: Yup.number().min(0, intl.formatMessage({ id: "numberMinError" })).nullable(),
      [FIELDS.FAST_WITHDRAWAL_FEE_AMOUNT]: Yup.number().min(0, intl.formatMessage({ id: "numberMinError" })).nullable(),
      [FIELDS.ADMIN_NOTE]: Yup.string().optional().nullable(),
    })
  }, [intl])
};

export const useServiceValidationSchema = () => {
  const intl = useIntl();

  return useMemo(() => {
    return Yup.object().shape({
      [FIELDS.NAME]: Yup.string().required(intl.formatMessage({ id: "transactionNameRequiredError" })).min(3, intl.formatMessage({ id: "transactionNameMinError" })),
      [FIELDS.FEE_AMOUNT]: Yup.number().min(0, intl.formatMessage({ id: "numberMinError" })).nullable(),
      [FIELDS.ADMIN_WITHDRAWAL_FEE_AMOUNT]: Yup.number().min(0.01, intl.formatMessage({ id: "numberMinError" })).required(intl.formatMessage({ id: "adminFeeRequiredError" })),
      [FIELDS.FAST_WITHDRAWAL_FEE_AMOUNT]: Yup.number().min(0, intl.formatMessage({ id: "numberMinError" })).nullable(),
      [FIELDS.ADMIN_NOTE]: Yup.string().optional().nullable(),
    })
  }, [intl])
};